// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_fq-0";